import React from "react";
import "./ConnectionLost.css";

const ConnectionLost = () => {

  const retryConnection = () => {
    window.location.reload();
  };

  return (
    <div className="con-lost-page">

      <div className="con-lost-container">

        <div className="con-lost-content">

          <h1 className="con-lost-oops">
            Oops!
          </h1>

          <h2>
            Server Connection Lost
          </h2>

          <p>
            We’re unable to connect to our servers right now.
            Please check your internet connection or try again
            in a few moments.
          </p>

          <button onClick={retryConnection}>
            ↻ &nbsp; Try Again
          </button>

        </div>


        <div className="con-lost-art">

          <div className="con-lost-cloud">
            ☁
            <span>⌁</span>
          </div>


          <div className="con-lost-wifi">
            ))))
          </div>


          <div className="con-lost-character">

            <div className="con-lost-ear con-lost-left"></div>
            <div className="con-lost-ear con-lost-right"></div>

            <div className="con-lost-head">

              <div className="con-lost-eye con-lost-left-eye"></div>
              <div className="con-lost-eye con-lost-right-eye"></div>

              <div className="con-lost-mouth"></div>

            </div>


            <div className="con-lost-body"></div>

            <div className="con-lost-hand"></div>

          </div>


          <div className="con-lost-server-box">

            <div className="con-lost-lights">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="con-lost-cross">
              ×
            </div>

          </div>


          <div className="con-lost-wire"></div>

        </div>

      </div>

    </div>
  );
};

export default ConnectionLost;